import { render, staticRenderFns } from "./EmailAccountView.vue?vue&type=template&id=bfe4ccfa&scoped=true&"
import script from "./EmailAccountView.vue?vue&type=script&lang=js&"
export * from "./EmailAccountView.vue?vue&type=script&lang=js&"
import style0 from "./EmailAccountView.vue?vue&type=style&index=0&id=bfe4ccfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe4ccfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfe4ccfa')) {
      api.createRecord('bfe4ccfa', component.options)
    } else {
      api.reload('bfe4ccfa', component.options)
    }
    module.hot.accept("./EmailAccountView.vue?vue&type=template&id=bfe4ccfa&scoped=true&", function () {
      api.rerender('bfe4ccfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/EmailAccountView.vue"
export default component.exports